import React from 'react';
import {
  Grid,
  Accordion,
  Tooltip,
  AccordionSummary,
  Box,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ShortBody, LongBody } from 'components/Typography';
import {
  StyledInfoIcon,
  StyledAccordionDetails,
} from 'components/AccordionContainer/styles';

export interface AccordionContainerType {
  title: string;
  subTitle: any;
  tooltipText?: string;
  details: any;
  handleOpenTooltipDialog?: Function;
}

const AccordionContainer = (props: AccordionContainerType) => {
  return (
    <Box padding={1}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            style={{ padding: '12px 8px' }}
          >
            <Grid item xs={7} sm={5} style={{ display: 'inline-flex' }}>
              <ShortBody style={{ fontWeight: 500, marginBottom: 0 }}>
                {props.title}
              </ShortBody>
              {props.tooltipText && (
                <Tooltip
                  title={props.tooltipText}
                  onClick={
                    props.handleOpenTooltipDialog &&
                    props.handleOpenTooltipDialog(
                      props.title,
                      props.tooltipText,
                    )
                  }
                >
                  <StyledInfoIcon fontSize={'small'} />
                </Tooltip>
              )}
            </Grid>
            <Grid item xs={4} sm={3} justify="flex-end" dir="ltr">
              <LongBody style={{ marginBottom: 0, textAlign: 'center' }}>
                {props.subTitle}
              </LongBody>
            </Grid>
          </Grid>
        </AccordionSummary>
        <StyledAccordionDetails>
          <Grid container spacing={1} style={{ padding: '0px 4px' }}>
            {props.details}
          </Grid>
        </StyledAccordionDetails>
      </Accordion>
    </Box>
  );
};

export default AccordionContainer;
